// feature/notion-chrome — minimal inline-SVG icon set for sidebar nav items.
// No new dependency; matches Lucide's stroke style (1.7px round caps).
import React from "react";

const baseProps = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

function S(children) {
  return (props) => (
    <svg {...baseProps} {...props}>{children}</svg>
  );
}

export const IconDashboard = S(
  <>
    <rect x="3" y="3" width="7" height="9" rx="1.5" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" />
    <rect x="3" y="16" width="7" height="5" rx="1.5" />
  </>
);

export const IconFolder = S(
  <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
);

export const IconPlus = S(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v8M8 12h8" />
  </>
);

export const IconClock = S(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </>
);

export const IconShield = S(
  <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z" />
);

export const IconInbox = S(
  <>
    <path d="M3 13h5l1 2h6l1-2h5" />
    <path d="M21 13l-3-7a2 2 0 0 0-1.8-1.2H7.8A2 2 0 0 0 6 6l-3 7v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5z" />
  </>
);

export const IconAlert = S(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v5M12 16.5h.01" />
  </>
);

export const IconAlertTri = S(
  <>
    <path d="M10.3 3.7L2 18a2 2 0 0 0 1.7 3h16.6a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </>
);

export const IconArchive = S(
  <>
    <rect x="3" y="3" width="18" height="5" rx="1" />
    <path d="M5 8v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8M10 12h4" />
  </>
);

export const IconUsers = S(
  <>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8" />
  </>
);

export const IconUserCog = S(
  <>
    <circle cx="9" cy="7" r="4" />
    <path d="M2 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" />
    <circle cx="19" cy="14" r="2" />
    <path d="M19 11v1M19 16v1M16 14h1M22 14h1" />
  </>
);

export const IconHistory = S(
  <>
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
    <path d="M3 4v4h4" />
    <path d="M12 7v5l3 2" />
  </>
);

export const IconCalendar = S(
  <>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M16 3v4M8 3v4M3 11h18" />
  </>
);

export const IconHourglass = S(
  <>
    <path d="M6 2h12M6 22h12" />
    <path d="M6 2c0 6 6 5 6 10s-6 4-6 10M18 2c0 6-6 5-6 10s6 4 6 10" />
  </>
);

export const IconRotate = S(
  <>
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
    <path d="M21 4v4h-4" />
    <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
    <path d="M3 20v-4h4" />
  </>
);

export const IconBarChart = S(
  <>
    <line x1="3" y1="21" x2="21" y2="21" />
    <rect x="6" y="13" width="3" height="6" />
    <rect x="11" y="9" width="3" height="10" />
    <rect x="16" y="5" width="3" height="14" />
  </>
);

export const IconSpreadsheet = S(
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
  </>
);

export const IconSearch = S(
  <>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3" />
  </>
);

export const IconChevron = S(
  <path d="M9 6l6 6-6 6" />
);

export const IconPin = S(
  <>
    <path d="M12 2v6l3 3-7 3 3 3-3 5-1-1 1-4-3-3 7-3-3-3V2h3z" />
  </>
);

export const IconExternalLink = S(
  <>
    <path d="M15 3h6v6" />
    <path d="M10 14L21 3" />
    <path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" />
  </>
);

// sprint84.1 — sidebar icon polish. Distinct icons for moderación,
// para archivar (existing IconArchive), mantenimiento, and the new
// "Informe Previsora" entry — all three were falling back to
// IconFolder in Sidebar.js:470, hurting scannability.

// Gavel — moderación / legal review actions.
export const IconGavel = S(
  <>
    <path d="M14 4l6 6" />
    <path d="M9 8l7 7" />
    <path d="M11 6l-7 7 3 3 7-7" />
    <path d="M14 15l5 5" />
    <path d="M4 22h12" />
  </>
);

// Wrench — mantenimiento / system tooling.
export const IconWrench = S(
  <path d="M14.7 6.3a4 4 0 0 0-5.7 5.7L3 18l3 3 6-6a4 4 0 0 0 5.7-5.7l-2.4 2.4-2.6-2.6 2.4-2.4z" />
);

// File-bar-chart — Informe Previsora (a report doc with quantitative content).
export const IconFileBarChart = S(
  <>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M8 18v-2" />
    <path d="M12 18v-5" />
    <path d="M16 18v-3" />
  </>
);

// feature/eva-litisoft — sparkle glyph for Eva (line-style, matches the set).
export const IconSparkle = S(
  <>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
    <path d="M18.5 15.5l.6 1.9 1.9.6-1.9.6-.6 1.9-.6-1.9-1.9-.6 1.9-.6z" />
  </>
);

// Map of label → icon used by Sidebar.js.
export const ICON_FOR_PATH = {
  "/dashboard":              IconDashboard,
  "/directora":              IconDashboard,
  "/abogado":                IconDashboard,
  "/cases":                  IconFolder,
  "/cases/new":              IconPlus,
  "/cases/late":             IconClock,
  "/audit":                  IconShield,
  "/insumos":                IconInbox,
  "/insumos/mine":           IconInbox,
  "/fallos":                 IconAlert,
  "/fallos/historic":        IconArchive,
  "/personas":               IconUsers,
  "/admin/users":            IconUserCog,
  "/admin/audit-log":        IconHistory,
  "/admin/sla-breaches":     IconCalendar,
  "/admin/error-queue":      IconAlertTri,
  "/admin/late-entry-queue": IconHourglass,
  "/admin/devueltos":        IconRotate,
  "/admin/reports/monthly":  IconBarChart,
  "/admin/exports":          IconSpreadsheet,
  // sprint84.1 — three sidebar items were defaulting to IconFolder via
  // the Sidebar.js:470 fallback. Explicit mappings for visual scan.
  "/moderacion":             IconGavel,
  "/para-archivar":          IconArchive,
  "/admin/maintenance":      IconWrench,
  "/admin/eva-litisoft":     IconSparkle,
  // sprint84.1 — anchor entries for "Informe Previsora". NavLink's
  // `to` carries the hash, so the lookup key includes the hash too.
  "/admin/exports#informe-mensual":     IconFileBarChart,
  "/admin/exports#casos-sin-respuesta": IconHourglass,
  "/directora/exports#informe-mensual": IconFileBarChart,
  "/directora/cases":        IconFolder,
  "/directora/devueltos":    IconRotate,
  "/directora/audit-log":    IconHistory,
  "/directora/reports":      IconBarChart,
  "/directora/exports":      IconSpreadsheet,
};

// Counts-aware mapping: nav items that should display a live count badge.
// Returns the count key from /api/users/me/sidebar-counts when applicable.
export const COUNT_KEY_FOR_PATH = {
  "/admin/devueltos":        "devueltos",
  "/directora/devueltos":    "devueltos",
  "/admin/late-entry-queue": "acciones_tardias",
  "/admin/error-queue":      "errores",
};
